import { getFormattedDate } from '@bbl-digital/snorre'
import { ddmmyyyyhhmm } from 'shared/constants/dateformats'

export const getUserImageUrl = (
  userId: string | undefined,
  strictHash = true
): string => {
  const imageHash = strictHash
    ? new Date().getTime()
    : `${getFormattedDate(new Date(), ddmmyyyyhhmm)}`
  return `${window.config.api.url}/personimage/user/${userId}/image?${imageHash}`
}
